module.exports = __webpack_public_path__ + "static/assets/3c4808dc1f8e6f9eaffcafb7f8f1e420.svg";